import { capitalize } from '@support/string';
import type { ReduxAction } from '../../types';

export type AppView =
  | 'Home'
  | 'Review'
  | 'People'
  | 'Notes'
  | 'Reminders'
  | 'Search'
  | 'Settings'
  | 'Contact - Detail'
  | 'Contact - Edit'
  | 'Group - Detail'
  | 'Group - Create'
  | 'Tour'
  | 'no view matched';

export interface LocationState {
  lastPathname?: string;
  pathname?: string;
  view?: AppView;
  pageSource?: string | undefined;
  redirect: string | null;
}

// Legacy mapping for event tracking
const pageSourceByPathname = {
  '/': 'Feed',
  '/review': 'Today',
  '/search': 'Search',
  '/people': 'Contact List',
  '/notes': 'Notes',
  '/reminders': 'Reminders',
};

const pathnameToPageSource = (pathname?: string): string | undefined => {
  if (pageSourceByPathname[pathname]) {
    return pageSourceByPathname[pathname];
  }

  const pathParts = pathname?.split('/');

  if (pathParts?.[1] == 'group') {
    return 'Group Detail';
  } else if (pathParts?.[1] == 'contact') {
    return 'Contact Detail';
  }

  return undefined;
};

const pathnameToView = (pathname: string): AppView => {
  const pathParts = pathname.split('/');

  if (pathParts[1] == '') {
    return 'Home';
  } else if (pathParts.length < 3) {
    return capitalize(pathParts[1]) as AppView;
  } else if (pathParts[1] == 'group') {
    return pathParts[2] == 'create' ? 'Group - Create' : 'Group - Detail';
  } else if (pathParts[1] == 'contact') {
    return pathParts[3] == 'form' ? 'Contact - Edit' : 'Contact - Detail';
  }

  return 'no view matched';
};

export function locationReducer(
  state: LocationState = { redirect: null },
  { type, payload }: ReduxAction,
) {
  switch (type) {
    case 'SET_LOCATION':
      if (state.pathname != payload.pathname) {
        return {
          ...state,
          lastPathname: state.pathname,
          pathname: payload.pathname,
          view: pathnameToView(payload.pathname),
          pageSource: pathnameToPageSource(payload.pathname),
        };
      }
      return state;

    case 'REDIRECT_LOCATION':
      return { ...state, redirect: payload.pathname };

    default:
      return state;
  }
}
